import Swiper, { Navigation, Lazy } from "swiper";

class PartnersSlider {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    const partnersCount = this.wrapper.find(".partners__slider .swiper-wrapper")[0].children.length;
    const enoughPartners = partnersCount >= 5;

    // Adjust navigation visibility (toggle based on enoughPartners)
    const sliderNav = $(".partners__slider-controls");
    if (sliderNav.length) {
      if (enoughPartners) {
        sliderNav.removeClass("hidden");
      } else {
        sliderNav.addClass("hidden");
      }
    }

    new Swiper(this.wrapper.find(".partners__slider")[0], {
      modules: [Lazy, Navigation],
      spaceBetween: 92,
      slidesPerView: "auto",
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 4,
      },
      navigation: enoughPartners ? {
        prevEl: this.wrapper.find(".swiper-button-prev")[0],
        nextEl: this.wrapper.find(".swiper-button-next")[0],
      } : false,
    });
  }

};

export default PartnersSlider;
